/**
 * Blueprint for the customer entity.
 */
export class CombinedCustomer {
  public targetCustomer: string;
  public sourceCustomer: string;
  public salutation: string;
  public firstName: string;
  public lastName: string;
  public company: string;
  public birthday: string;
  public email: string;
  public externalAuthorization: string;
  public phone: string;
  public mobile: string;
  public gender: string;
  public title: string;
  public addresses?: Array<number> = [];
  public attributes?: Array<number> = [];
  public membership?: string;
  public campaiMembership?: string;

  constructor(targetCustomer: any, sourceCustomer: any) {
    if (targetCustomer) {
      this.targetCustomer = targetCustomer['@id'];
      this.sourceCustomer = sourceCustomer['@id'];
      this.salutation = targetCustomer.salutation.value;
      this.firstName = targetCustomer.firstName;
      this.lastName = targetCustomer.lastName;
      this.company = targetCustomer.company;
      this.birthday = targetCustomer.birthday?.date.toISOString().split('T')[0];
      this.email = targetCustomer.searchEmail;
      this.externalAuthorization = targetCustomer.externalAuthorization;
      this.phone = targetCustomer.phone;
      this.mobile = targetCustomer.mobile;
      this.gender = targetCustomer.gender;
      this.title = targetCustomer.title;
      this.membership = targetCustomer.membership ? targetCustomer.membership['@id'] : null;
      this.campaiMembership = targetCustomer.campaiMembership ? targetCustomer.campaiMembership['@id'] : null;

      for (const address of targetCustomer.addresses) {
        this.addresses.push(address.id);
      }

      for (const attribute of targetCustomer.attributes) {
        this.attributes.push(attribute.customerId);
      }
    }
  }
}
